// Modules
import React from "react";

//Components 
import ToolTip from "Generic/ToolTip";

// Styles
import './PointsForSearch.sass';
import moment from "moment";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

type Props = {
    selectedDate: Date,
    currentBalance: string,
    potentialBalance: string
}

class PointsForSearch extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const checkIn: string = moment(this.props.selectedDate).format("DD MMM YYYY");
        const { localize } = this.context;
        return (
            <div className="points-search">
              <div className="points-searchheading">
                <div className="text">{localize('static.content.select-availability-points-balance-section-label-header')}</div>
                <div className="icon">
                  <ToolTip 
                    tabIndex={0} 
                    tip={[
                      {
                        label: "",
                        desc: localize("static.content.select-points-for-this-search-tooltip")
                      }
                    ]}
                    id='pointsforsearch' 
                    useRefToPosition={false}>
                    <span className="question-icon pts-tooltip">{"?"}</span>
                  </ToolTip>
                </div>          
              </div>
              <div className="arrow-right"></div>
              <div className="points-searchdetails-date">
                  <div className="points-column">
                    <div className="points-text">
                      <b>{checkIn}</b>
                    </div>
                  </div>
                </div>
              <div className="points-searchdetails">
                <div className="points-column">
                  <div className="points-key"><b>{localize('static.content.select-availability-points-balance-current-balance-label')}:</b></div>
                  <div className="points-text">
                    <b>{this.props.currentBalance}</b>
                  </div>
                </div>
              </div>
              <div className="points-searchdetails">
                <div className="points-column">
                  <div className="points-key"><b>{localize('static.content.select-availability-points-balance-potential-balance-label')}:</b></div>
                  <div className="points-text">
                    <b>{this.props.potentialBalance}</b>
                  </div>
                </div>
              </div>
      
            </div>
          );
    }
}

PointsForSearch.contextType = LocalizationContext;
export default PointsForSearch;